module.exports = __webpack_public_path__ + "img/orange-3.a7ca4620.png";